<div class="dashboard-container">
  <!-- Header -->
  <div class="">

  </div>

  <!-- Stats Cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
    <!-- Kontrolltermine Aktuell -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-lg transition-shadow" (click)="navigateToStats('kontrolltermine')">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-blue-100 dark:bg-blue-900">
          <svg class="w-6 h-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Kontrolltermine Aktuell</p>
          <p class="text-2xl font-semibold text-gray-900 dark:text-white">{{ stats.kontrolltermine_aktuell }}</p>
        </div>
      </div>
    </div>

    <!-- Anzahl Kunden -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-lg transition-shadow" (click)="navigateToStats('clients')">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-green-100 dark:bg-green-900">
          <svg class="w-6 h-6 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Anzahl Kunden</p>
          <p class="text-2xl font-semibold text-gray-900 dark:text-white">{{ stats.anzahl_kunden }}</p>
        </div>
      </div>
    </div>

    <!-- Anzahl Standorte -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-lg transition-shadow" (click)="navigateToStats('standorte')">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-purple-100 dark:bg-purple-900">
          <svg class="w-6 h-6 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Anzahl Standorte</p>
          <p class="text-2xl font-semibold text-gray-900 dark:text-white">{{ stats.anzahl_standorte }}</p>
        </div>
      </div>
    </div>

    <!-- Kontrolltermine in Bearbeitung -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-lg transition-shadow" (click)="navigateToStats('bearbeitung')">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-orange-100 dark:bg-orange-900">
          <svg class="w-6 h-6 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">In Bearbeitung</p>
          <p class="text-2xl font-semibold text-gray-900 dark:text-white">{{ stats.kontrolltermine_bearbeitung }}</p>
        </div>
      </div>
    </div>

    <!-- Kontrolltermine Freigabe -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-lg transition-shadow" (click)="navigateToStats('freigabe')">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-yellow-100 dark:bg-yellow-900">
          <svg class="w-6 h-6 text-yellow-600 dark:text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Auf Freigabe</p>
          <p class="text-2xl font-semibold text-gray-900 dark:text-white">{{ stats.kontrolltermine_freigabe }}</p>
        </div>
      </div>
    </div>
  </div>




  <!-- Main Content Grid -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
    <!-- Nächste Freigaben -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
      <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Nächste Freigaben</h3>
          <button 
            routerLink="/kontrolltermine"
            class="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium">
            Alle anzeigen →
          </button>
        </div>
      </div>
      <div class="p-3">
        <div class="space-y-1">
          <div *ngFor="let freigabe of naechsteFreigaben" 
               (click)="navigateToFreigabe(freigabe)"
               class="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
            <div class="flex items-center space-x-2">
              <div class="w-2 h-2 rounded-full" [ngClass]="getStatusColor(freigabe.status)"></div>
              <div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ freigabe.kunde }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Fällig: {{ freigabe.faellig }}</p>
              </div>
            </div>
            <span class="text-xs text-gray-500 dark:text-gray-400">{{ freigabe.tage }} Tage</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Letzte Berichte -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
      <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Letzte Berichte</h3>
          <button 
            routerLink="/reports"
            class="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium">
            Alle anzeigen →
          </button>
        </div>
      </div>
      <div class="p-3">
        <div class="space-y-1">
          <div *ngFor="let bericht of letzteBerichte" 
               (click)="navigateToBericht(bericht)"
               class="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
            <div class="flex items-center space-x-2">
              <div class="w-6 h-6 rounded-full flex items-center justify-center" [ngClass]="getPriorityColor(bericht.prioritaet).bg">
                <svg class="w-3 h-3" [ngClass]="getPriorityColor(bericht.prioritaet).text" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
              </div>
              <div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ bericht.titel }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ bericht.kunde }} - {{ bericht.datum }}</p>
              </div>
            </div>
            <span class="text-xs px-2 py-1 rounded-full" [ngClass]="getPriorityColor(bericht.prioritaet).bg + ' ' + getPriorityColor(bericht.prioritaet).text">{{ bericht.prioritaet }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bulk Kontrolltermine Generation -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
    <div class="lg:col-span-2">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
        <!-- Toggle Button (shown when interface is collapsed) -->
        <div *ngIf="!showBulkGenerationInterface" class="p-4">
          <button (click)="toggleBulkGenerationInterface()" 
                  class="bg-blue-100 text-blue-700 px-4 py-2 rounded-md hover:bg-blue-200 transition-colors flex items-center space-x-2 text-sm">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
            <span>Kontrolltermine für {{bulkGenerationConfig.year}} generieren</span>
          </button>
        </div>

        <!-- Full Interface (shown when expanded) -->
        <div *ngIf="showBulkGenerationInterface">
          <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
              Kontrolltermine Bulk-Generierung
            </h3>
            <button (click)="toggleBulkGenerationInterface()" 
                    class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <div class="p-6">
        <!-- Year Selection -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Jahr
          </label>
          <select [(ngModel)]="bulkGenerationConfig.year" 
                  (change)="onYearChange()"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md">
            <option [value]="currentYear">{{currentYear}}</option>
            <option [value]="nextYear">{{nextYear}}</option>
          </select>
          <p class="text-xs text-gray-500 mt-1">
            Nur aktuelles oder nächstes Jahr verfügbar
          </p>
        </div>
        
        <!-- Month Range Selection -->
        <div class="grid grid-cols-2 gap-4 mb-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Von Monat
            </label>
            <select [(ngModel)]="bulkGenerationConfig.fromMonth" 
                    (change)="onMonthRangeChange()"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md">
              <option *ngFor="let month of availableFromMonths" [value]="month.value">
                {{month.label}}
              </option>
            </select>
            <p class="text-xs text-gray-500 mt-1">
              <span *ngIf="bulkGenerationConfig.year === currentYear">Nur zukünftige Monate verfügbar</span>
              <span *ngIf="bulkGenerationConfig.year === nextYear">Alle Monate verfügbar</span>
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Bis Monat
            </label>
            <select [(ngModel)]="bulkGenerationConfig.toMonth" 
                    (change)="onMonthRangeChange()"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md">
              <option *ngFor="let month of availableToMonths" [value]="month.value">
                {{month.label}}
              </option>
            </select>
            <p class="text-xs text-gray-500 mt-1">
              Bis Ende des Jahres
            </p>
          </div>
        </div>
        
        <!-- Generation Summary -->
        <div class="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <h4 class="font-medium text-blue-900 dark:text-blue-100 mb-2">
            Generierung für {{bulkGenerationConfig.year}}
          </h4>
          <p class="text-sm text-blue-800 dark:text-blue-200">
            Von {{getMonthLabel(bulkGenerationConfig.fromMonth)}} bis {{getMonthLabel(bulkGenerationConfig.toMonth)}}
          </p>
          <p class="text-xs text-blue-600 dark:text-blue-300 mt-1">
            Alle aktiven Standorte werden berücksichtigt
          </p>
        </div>
        
        <!-- Action Buttons -->
        <div class="flex space-x-3">
          <button (click)="startBulkGeneration(false)" 
                  [disabled]="isBulkGenerating || !isValidMonthRange()"
                  class="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
            <span *ngIf="!isBulkGenerating">Kontrolltermine für {{bulkGenerationConfig.year}} generieren</span>
            <span *ngIf="isBulkGenerating" class="flex items-center justify-center">
              <mat-spinner diameter="16" class="mr-2"></mat-spinner>
              Generiere...
            </span>
          </button>
          <button (click)="startBulkGeneration(true)" 
                  [disabled]="isBulkGenerating || !isValidMonthRange()"
                  class="bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
            Test Run
          </button>
        </div>
        
        <!-- Validation Messages -->
        <div *ngIf="!isValidMonthRange()" class="mt-3 p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
          <p class="text-sm text-yellow-800 dark:text-yellow-200">
            <mat-icon class="w-4 h-4 mr-1 align-text-bottom">warning</mat-icon>
            <span *ngIf="bulkGenerationConfig.year === currentYear">
              Bitte wählen Sie einen gültigen Monatsbereich für {{currentYear}} (nur zukünftige Monate)
            </span>
            <span *ngIf="bulkGenerationConfig.year === nextYear">
              Bitte wählen Sie einen gültigen Monatsbereich für {{nextYear}}
            </span>
          </p>
        </div>
        
        <!-- Progress Display -->
        <div *ngIf="bulkGenerationProgress" class="mt-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
          <h4 class="font-medium text-gray-900 dark:text-white mb-2">Generierungsfortschritt</h4>
          <div class="space-y-2">
            <div class="flex justify-between text-sm">
              <span>Kandidaten gefunden:</span>
              <span>{{bulkGenerationProgress.run.total_candidates}}</span>
            </div>
            <div class="flex justify-between text-sm">
              <span>Erstellt:</span>
              <span class="text-green-600 dark:text-green-400">{{bulkGenerationProgress.run.created_count}}</span>
            </div>
            <div class="flex justify-between text-sm">
              <span>Übersprungen:</span>
              <span class="text-yellow-600 dark:text-yellow-400">{{bulkGenerationProgress.run.skipped_existing_count}}</span>
            </div>
            <div class="flex justify-between text-sm">
              <span>Fehler:</span>
              <span class="text-red-600 dark:text-red-400">{{bulkGenerationProgress.run.errors_count}}</span>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Empty space for 1/3 width -->
    <div class="lg:col-span-1">
      <!-- This space is intentionally left empty to maintain the 2/3 - 1/3 layout -->
    </div>
  </div>


